import { ReqBodyType } from './types/reqBody';
import HttpClient from './utils/HttpClient';

interface CompanySettingsServiceI {
  codEmpresa?: number;
  token: string;
  reqBody?: ReqBodyType;
  codUsu?: string;
  perfilUsu?: string | number;
  tipoAcao?: string | number;
}

class CompanySettingsService {
  private readonly httpClient: HttpClient;
  constructor() {
    this.httpClient = new HttpClient(process.env.REACT_APP_PATHNAME ?? '');
  }

  getCompanySettings = async ({
    codEmpresa,
    tipoAcao = 13,
    codUsu,
    perfilUsu,
    token,
  }: CompanySettingsServiceI) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_CadCliConfig?codEmpresa=${codEmpresa}&tipoAcao=${tipoAcao}&codUsu=${codUsu}&perfilUsu=${perfilUsu}`,
    });
  };

  getListsToSetupCompany= async ({
    codEmpresa,
    tipoAcao = 14,
    codUsu,
    perfilUsu,
    token,
  }: CompanySettingsServiceI) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_ListasGerais?codEmpresa=${codEmpresa}&tipoAcao=${tipoAcao}&codUsu=${codUsu}&perfilUsu=${perfilUsu}`,
    });
  };

  editOrSetCompanySettings = async ({
    token,
    reqBody,
    codUsu,
    perfilUsu,
    codEmpresa,
  }: CompanySettingsServiceI) => {
    return this.httpClient.post({
      token,
      path: `/api/SMob_CadCliConfig?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}&valorLong=0&valorInt=0`,
      reqBody,
    });
  };

  uploadImage = async ({
    token,
    codUsu,
    perfilUsu,
    codEmpresa,
    reqBody,
  }: CompanySettingsServiceI) => {
    return this.httpClient.post({
      token,
      path: `/api/SMob_DocsArq?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}&tipoArquivo=1&valorLong=0&valorInt=0`,
      contentType: 'multipart/form-data',
      reqBody,
    });
  };
}

export default new CompanySettingsService();
